import { render, staticRenderFns } from "./AggiungiUtente.vue?vue&type=template&id=72105421&scoped=true"
import script from "./AggiungiUtente.vue?vue&type=script&lang=js"
export * from "./AggiungiUtente.vue?vue&type=script&lang=js"
import style0 from "./AggiungiUtente.vue?vue&type=style&index=0&id=72105421&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72105421",
  null
  
)

export default component.exports